import type { CreateOverlayReturn } from "@chakra-ui/react";

export const closeOverlaySafely = (
  overlay: Pick<CreateOverlayReturn<never>, "close">,
  id: string,
) => {
  try {
    overlay.close(id);
  } catch {
    console.error("Overlay close failed");
  }
};
